import { BaseResourceModel } from '../../models/base-resource.model';
import { Favorecido, TipoAgenteInvestimento } from 'eddydata-lib';
import { FundoInvestimento } from './fundo-investimento.model';

export class AgenteFundo extends BaseResourceModel {
  constructor(
    public favorecido?: Favorecido,
    public tipo?: TipoAgenteInvestimento,
    public tempo_atuacao?: number,
    public total_patrimonio?: number,
    public fundo_investimento?: FundoInvestimento) {
    super();
  }
  static converteJson(json: any): AgenteFundo {
    return Object.assign(new AgenteFundo(), json);
  }
}